import "./ErrorScreen.css";

import { t } from "i18next";

const DefaultErrorText = t("errorState.error.unableToFetch");

export const ErrorScreen = ({
  errorText = DefaultErrorText,
  refetch,
}: {
  errorText?: string;
  refetch?: () => void;
}) => {
  const handleRefetch = () => {
    if (refetch) refetch();
    else window.location.reload();
  };

  return (
    <div className="error-screen">
      <p className="error-text">{errorText}</p>

      <button className="refresh-button" onClick={handleRefetch}>
        {t("actions.refresh")}
      </button>
    </div>
  );
};
